function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
export var ContentSegments = /*#__PURE__*/ function() {
    "use strict";
    function ContentSegments() {
        _class_call_check(this, ContentSegments);
    }
    _create_class(ContentSegments, null, [
        {
            key: "fromAdBreaks",
            value: function fromAdBreaks(mainContentDuration, adBreaks) {
                if (adBreaks.length === 0) {
                    return [
                        {
                            startPosition: 0,
                            endPosition: mainContentDuration !== null && mainContentDuration !== void 0 ? mainContentDuration : Infinity
                        }
                    ];
                }
                var contentSegments = [];
                adBreaks.forEach(function(adBreak, index) {
                    var nextAdBreak = adBreaks[index + 1];
                    // If there is no pre-roll, then make a segment for the time between content start and first adBreak
                    var hasNoPreroll = index === 0 && !(adBreak.position === 0 || adBreak.position === 'start');
                    if (hasNoPreroll) {
                        contentSegments.push({
                            startPosition: 0,
                            endPosition: !isNaN(adBreak.position) ? adBreak.position : mainContentDuration || Infinity
                        });
                    }
                    contentSegments.push({
                        startPosition: contentSegments.length === 0 ? 0 : contentSegments[contentSegments.length - 1].endPosition,
                        endPosition: nextAdBreak && !isNaN(nextAdBreak.position) ? nextAdBreak.position : mainContentDuration || Infinity
                    });
                });
                return contentSegments.map(function(e) {
                    return {
                        startPosition: Math.floor(e.startPosition),
                        endPosition: Math.floor(e.endPosition)
                    };
                });
            }
        },
        {
            key: "findSegment",
            value: function findSegment(contentSegments, position) {
                var flooredPosition = Math.floor(position);
                var predicate = function(contentSegment) {
                    return flooredPosition > contentSegment.startPosition && flooredPosition < contentSegment.endPosition;
                };
                return contentSegments.findIndex(predicate) + 1;
            }
        }
    ]);
    return ContentSegments;
}();

//# sourceMappingURL=content-segments.js.map